const getCurrentLocation = () => {
  const hash = window.location.hash.replace(/^#/, '');
  const queryStart = hash.indexOf('?');

  if (queryStart === -1) {
    return {
      pathname: hash || '/',
      search: '',
    };
  }

  return {
    pathname: hash.slice(0, queryStart) || '/',
    search: hash.slice(queryStart),
  };
};

const toHash = ({ pathname = '/', search = '' }) => `${pathname}${search}`;

const dispatchNavigation = () => {
  window.dispatchEvent(new PopStateEvent('popstate'));
};

const push = (location) => {
  const nextLocation =
    typeof location === 'string' ? { pathname: location } : location;
  const hash = toHash(nextLocation);

  window.history.pushState(
    window.history.state,
    '',
    `${window.location.pathname}${window.location.search}#${hash}`
  );
  dispatchNavigation();
};

const replace = (location) => {
  const nextLocation =
    typeof location === 'string' ? { pathname: location } : location;
  const hash = toHash(nextLocation);

  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${window.location.search}#${hash}`
  );
  dispatchNavigation();
};

export const hashHistory = {
  getCurrentLocation,
  push,
  replace,
};
